import {
	GetAllSourceProgram,
	GetHostOstypeList,
	GetSoftSortList,
	GetSoftTypeList
} from '@/api/modules/basicData/clientApi'
import axios from 'axios'
const client = {
	state: {
		softWareTable: '',
		softWareForm: {
			enableSys: [],
			softWareType: [],
			softWareClass: [],
		}
	},
	getters: {
		softWareTableCount: state => {
			//return state.softWareTable.length
		},
		softWareTableCount1: (state, getters) => {
			//return getters.softWareTableCount
		},
		tableCountBig1: (state) => (param) => {
			//return state.softWareTable.length > param
		}
	},
	mutations: {
		setTableData(state, data) {
			state.softWareTable = JSON.stringify(data)
		},
		setFormData(state,payload) {
			//console.log(payload)
			state.softWareForm.enableSys = payload.resDetailOstype
			state.softWareForm.softWareType = payload.resDetailSort
			state.softWareForm.softWareClass = payload.resDetailType
		},
	},
	actions: {
		increment(context) {
			context.commit('increment')
		},
		getTableData({
			state,
			commit
			//dispatch,//继续分发
			//rootState//根
		}) {
			return new Promise((resolve, reject) => {
				GetAllSourceProgram().then(res => {
					commit('setTableData', res);
					resolve(res);
				}).catch(error => {
					reject(error)
				})
			})
		},
		getFormData({
			commit
		}) {
			return new Promise((resolve, reject) => {
				axios.all([
					GetHostOstypeList(),
					GetSoftSortList(),
					GetSoftTypeList()
				]).then(axios.spread((resDetailOstype, resDetailSort, resDetailType) => {
					// 打印两个请求的响应值  
					commit('setFormData', {
						resDetailOstype:resDetailOstype,
						resDetailSort:resDetailSort,
						resDetailType:resDetailType
					});
					resolve({
						resDetailOstype:resDetailOstype,
						resDetailSort:resDetailSort,
						resDetailType:resDetailType
					});
				})).catch(error => {
					reject(error)
				})
			})
		}
	}
}
export default client